<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="3"></ucMenu>
					<div class="right_con">
						<div class="goods_main">
							<p class="fb">订单列表</p>
							<div class="select_wrap">
								<el-select class="w290" v-model="searchData.platform_type" placeholder="请选择" clearable filterable >
									<p slot="prefix" class="label_title">下单平台</p>
									<el-option v-for="item in platformTypeList" :key="item.val" :label="item.text" :value="item.val">
									</el-option>
								</el-select>
								<el-select class="w290" v-model="searchData.shop_id" placeholder="请选择" clearable>
									<p slot="prefix" class="label_title">店铺名</p>
									<el-option v-for="item in arrShop" :key="item.key" :label="item.key" :value="item.val">
									</el-option>
								</el-select>
								<el-input class="w290" v-model="searchData.product_name" placeholder="请输入商品标题/商品ID" clearable>
									<p slot="prefix" class="label_title">商品信息</p>
								</el-input>
								<el-input class="w290" v-model="searchData.dd_order_id" placeholder="请输入店铺订单号" clearable>
									<p slot="prefix" class="label_title">店铺订单号</p>
								</el-input>
								<el-input class="w290" v-model="searchData.pdd_order_id" placeholder="请输入采购订单号" clearable>
									<p slot="prefix" class="label_title">采购订单号</p>
								</el-input>

								<el-input class="w290" v-model="searchData.pdd_purchase_msg" placeholder="请输入采购备注" clearable>
									<p slot="prefix" class="label_title">采购备注</p>
								</el-input>
								<el-input class="w290" v-model="searchData.pdd_account" placeholder="请输入PDD账号" clearable>
									<p slot="prefix" class="label_title">PDD账号</p>
								</el-input>
								<el-input class="w290" v-model="searchData.pdd_express_no" placeholder="请输入采购快递单号" clearable>
									<p slot="prefix" class="label_title">采购快递单号</p>
								</el-input>
								<el-input class="w290" v-model="searchData.return_logistics_code" placeholder="请输入买家退货单号" clearable>
									<p slot="prefix" class="label_title">买家退货单号</p>
								</el-input>
								<el-input class="w290" v-model="searchData.pdd_return_logistics_code" placeholder="请输入平台退货单号" clearable>
									<p slot="prefix" class="label_title">平台退货单号</p>
								</el-input>
								<el-date-picker class="w290"
								                v-model="searchData.create_time"
								                type="datetimerange"
								                align="right"
								                unlink-panels
								                range-separator="至"
								                start-placeholder="买家下单开始日期"
								                end-placeholder="买家下单结束日期"
								                value-format="yyyy-MM-dd HH:mm:ss"
								                @onPick="datePick"
								                :picker-options="pickerOptions"
								                :default-time="['00:00:00', '23:59:59']">
								</el-date-picker>
								<el-date-picker class="w290"
								                v-model="searchData.pdd_order_time"
								                type="datetimerange"
								                align="right"
								                unlink-panels
								                range-separator="至"
								                start-placeholder="采购下单开始日期"
								                end-placeholder="采购下单结束日期"
								                value-format="yyyy-MM-dd HH:mm:ss"
								                @onPick="datePick"
								                :picker-options="pickerOptions"
								                :default-time="['00:00:00', '23:59:59']">
								</el-date-picker>
								<el-button plain size="small" @click="doSearch()">查询</el-button>
								<el-button plain size="small" @click="resetSearch()">重置</el-button>
							</div>
							<div class="tabs_wrap">
								<p class="tab" :class="!searchData.pdd_order_status?'active':''" @click="changeStatus('')">全部订单</p>
								<p class="tab" :class="searchData.pdd_order_status==s.val?'active':''" v-for="(s,i) in arrPddStatus" :key="i" @click="changeStatus(s.val)">{{ s.text }}
									<el-badge class="mark" :value="s.num" v-if="s.num > 0"/>
								</p>
								<!-- <p class="tab">已签收未确认<i class="iconfont icon-clock"></i></p>
								<p class="tab">已确认未评价<i class="iconfont icon-clock"></i></p> -->
							</div>
							<div class="totals_btn">
								<p class="totals">共{{ page_data.total }}条</p>
								<el-button plain size="small" @click="bindBatDelete()">批量删除</el-button>
								<!-- <el-button plain size="small" @click="bindBatPurchase()">批量采购</el-button> -->
								<el-button plain size="small" v-if="searchData.pdd_order_status == 100" @click="bindBatAlibabaPurchase()">批量厂家直采</el-button>
								<el-button plain size="small" @click="bindBatCancelPurchase()">批量取消</el-button>
								<el-button plain size="small" @click="orderExport()">批量导出</el-button>
								<el-button plain size="small" @click="sendGiftOrder()" v-if="searchData.pdd_order_status < 130">发礼品单</el-button>
								<!-- <el-button plain size="small" @click="openAutoGift()">自动发礼品</el-button> -->
								<el-button plain size="small" @click="setNotDeal()" v-if="searchData.pdd_order_status === 140">批量完结</el-button>
								<el-button plain size="small" @click="openAutoRefundReason()">自动同意售后</el-button>
								<el-button plain size="small" @click="editReturnAddressExpireDay()">自动删退换地址</el-button>
								<el-button plain size="small" @click="editSyncReturnAddressSet()">获取退货地址</el-button>
								<el-button plain size="small" :loading="sync_order_queue_count>0" @click="openSyncDdOrderQueue()">{{sync_order_queue_count>0?'正在同步':'同步抖店订单'}}</el-button>
								<el-button plain size="small" v-if="searchData.pdd_order_status == 100||searchData.pdd_order_status == 101" @click="openBatchAlibabaConnect">批量关联</el-button>
							</div>
							<div class="list_title">
								<label class="checkall">
									<el-checkbox v-model="checkAll" @change="bindCheckAll">全选</el-checkbox>
								</label>
								<p class="t1">货品信息<i class="iconfont el-icon-view" style="font-size: 14px;margin-left: 5px;cursor: pointer;" @click="showOrderInfo()"></i></p>
								<p class="t2">售价/数量</p>
								<p class="t3">订单状态</p>
								<p class="t4">金额</p>
								<p class="t5">退货信息</p>
								<!--                <p class="t6">采购状态</p>-->
								<p class="t7">操作</p>
							</div>
							<ul class="order_list">
								<el-checkbox-group v-model="checkList" @change="bindCheckList">
									<li v-for="(item,index) in list" :key="index">
										<div class="info_top">
											<div class="order_nums">
												<div class="check_box">
													<el-checkbox :label="item.id" :key="item.id" :checked="item.checked"></el-checkbox>
												</div>
												<p class="num" v-if="item.dd_shop">
													<span class="shop_name">{{  isHideOrderInfo ? '************' : item.dd_shop.shop_name }}</span>
													抖店单号：{{ item.dd_order_id }}<i class="iconfont icon-fuzhi" @click="bindCopy(item.dd_order_id)"></i>
												</p>
												<p class="num" v-if="item?.pdd_order?.order_id">
													{{ item.pdd_order?.buy_mode == 3 ? '巴巴' : '多多'}}单号：{{ item.pdd_order.order_id }}<i class="iconfont icon-fuzhi" @click="bindCopy(item.pdd_order.order_id)"></i>
												</p>
												<p class="num" v-if="!item.dd_shop"><span class="shop_name">店铺已删除</span>：{{ item.dd_order_id }}<i class="iconfont icon-fuzhi" @click="bindCopy(item.dd_order_id)"></i></p>

												<p class="num" v-if="item.shop_type==0">平台单号：{{ item.order_no }}<i class="iconfont icon-fuzhi" @click="bindCopy(item.order_no)"></i></p>
												<p class="date">下单时间：{{ item.create_time }}</p>
												<!--											<i v-if="item.dd_order_id!='0'" class="btn-remark el-icon-s-flag" @click="showRemark(item.order_id)" :style="{'color':item.seller_remark_starts_info.color}"></i>-->
											</div>
											<div class="order_flag">
												<!-- <el-tooltip class="item" effect="dark" content="点击查看原订单" placement="top" v-if="item.pid > 0">
													<p class="flag_box" @click="showOriginalOrder(item.pdd_order.dd_order_id)">换货单</p>
												</el-tooltip>
												<el-tooltip class="item" effect="dark" content="点击查看换货单" placement="top" v-if="item.has_child_order > 0">
													<p class="flag_box old" @click="showOriginalOrder(item.pdd_order.dd_order_id,2)">换货原单</p>
												</el-tooltip> -->
												<el-tooltip class="item" effect="dark" content="点击查看原订单" placement="top"
													v-if="item.is_exchange==1 && item.dd_order_id.includes('B')">
													<p class="flag_box"
														@click="showOriginalOrder(item.dd_order_id)">换货单</p>
												</el-tooltip>
												<el-tooltip class="item" effect="dark" content="点击查看换货单" placement="top"
													v-if="item.is_exchange == 1 && !item.dd_order_id.includes('B')">
													<p class="flag_box old"
														@click="showOriginalOrder(item.dd_order_id, 2)">换货原单
													</p>
												</el-tooltip>
											</div>
										</div>


										<div class="order_info">
											<div class="order_product">
												<div class="product_item">
													<div class="goods_info">
														<div class="img_box"><img class="coverimg" :src="item.product_pic" @click="openImg(item)"/></div>
														<div class="con_box">
															<p class="title">{{  isHideOrderInfo ? '************' : item.product_name }}</p>
															<p class="t1">{{ item.spec_value }}</p>
															<p class="t1" v-if="item.is_exchange == 1">换货规格：{{ item.exchange_product_spec_str }}</p>
															<p class="t2">
																<span>商品编码：{{ item.pdd_sku_id ?? item.pdd_code }}</span>
																<span @click="editProductCode(item,index)" style="cursor: pointer;text-align: justify;">
								                                    <i class="el-icon-edit" style="margin-left: 5px;"></i>
								                                </span>
																<span @click="bindCopy('https://mobile.yangkeduo.com/goods.html?goods_id='+(item.pdd_sku_id ?? item.pdd_code))" style="cursor: pointer;text-align: justify;">
								                                    <i class="iconfont icon-fuzhi" style="margin-left: 5px;font-size: 14px;"></i>
								                                </span>
															</p>
															<p class="t1">
																<span>商品ID：{{ item.goods_id ?? item.goods_id }}</span>
															</p>
															<p class="t2" v-if="item.supplier">供应商：{{ item.supplier.nickname }}</p>
															<p class="t2" v-if="item.deliver_ageing">发货时效：{{ item.deliver_ageing }}</p>
															<p class="t2" v-if="item.supplier_remark">
																<el-tooltip class="item" effect="dark" :content="item.supplier_remark" placement="top">
																	<span class="sp_remark">供应商备注：{{ item.supplier_remark }}</span>
																</el-tooltip>
															</p>
															<p class="stock_msg" v-if="item.abb_purchase_amount > 0 && searchData.pdd_order_status == 100">
																<span>直采价：{{ item.abb_purchase_amount ?? '0.00' }}</span>
															</p>
															<p class="stock_msg" v-if="item.ready_stock_amount > 0 && searchData.pdd_order_status == 100">
																<span>直发价：{{ item.ready_stock_amount ?? '0.00' }}</span>
															</p>
															<p class="stock_msg" v-if="item.pdd_order?.order_id">
																<span>采购价：{{ item.pdd_order.pdd_pay_amount ?? '0.00' }}</span>
																<span>代发费：{{ item.pdd_order.freight }}</span>
															</p>
															<p class="stock_msg" v-if="item.pdd_order?.order_id">
																<span>采购费：{{ item.pdd_order.purchase_fee ?? '0.00' }}</span>
																<span>毛利润：{{ item.profit }}</span>
															</p>
															<p class="stock_msg" v-if="item.stock_msg">{{ item.stock_msg }}</p>
															<!-- <p class="guanlian" :class="item.pdd_product_sku_id==0&&'red'" v-if="(item.pdd_status==0 || item.pdd_status==100) && (item.order_status!=1 && item.order_status!=4)"><span @click="callCG(item)">{{ item.pdd_product_sku_id != 0 ? "修改关联" : "关联商品" }}</span></p> -->
															<p class="guanlian" :class="!isValidAlibabaPddCode(item)&&'red'" v-if="(item.pdd_status==0 || item.pdd_status==100||(item.pdd_status == 140&&item.is_exchange==1&&!item.dd_order_id.includes('B'))) && (item.order_status!=1 && item.order_status!=4)">
																<span @click="alibabaCG(item)">{{ isAlibabaDirectLinked(item) ? "修改直采关联" : "厂家直采关联" }}</span>
															</p>
														</div>
													</div>
													<div class="goods_num">
														<p class="t1">{{ item.pay_amount }}</p>
														<p class="t2">x{{ item.item_num }}</p>
													</div>
													<div class="goods_sales">
														<p class="t1">抖店状态:{{ item.order_status_text }}</p>
														<p class="t1">采购状态:{{ item.pdd_order?.status_name ? item.pdd_order?.status_name:item.abb_purchase_msg?item.abb_purchase_msg: '暂无' }}</p>
														<p class="t1" v-if="item.pdd_status== 120 && item.order_alibaba_order?.step_date > 0">发货失败原因：{{item.order_alibaba_order?item.order_alibaba_order.step_remark:'未知错误'}}</p>
														<p v-if="item.pay_time > 0" class="t2">
															<el-tooltip class="item" effect="dark" content="买家付款时间" placement="top">
																<i class="el-icon-time" style="color:grey; transform: rotate(90deg);"></i>
															</el-tooltip>
															{{ item.pay_time_str ?? '暂无' }}
														</p>
														<p v-if="item.pdd_order?.order_time > 0" class="t2">
															<el-tooltip class="item" effect="dark" content="采购下单时间" placement="top">
																<i class="el-icon-time" style="color:grey;"></i>
															</el-tooltip>
															{{ item.pdd_order?.order_time_str ?? '暂无' }}
														</p>
														<p v-if="item.pdd_order?.sync_time > 0" class="t2">
															<el-tooltip class="item" effect="dark" content="采购同步时间" placement="top">
																<i class="el-icon-sort" style="color:grey; transform: rotate(90deg);"></i>
															</el-tooltip>
															{{ item.pdd_order?.sync_time_str ?? '暂无' }}
														</p>
														<p v-if="item.order_status!=4" style="display: flex;align-items: center;cursor: pointer;">买家信息：<i class="iconfont el-icon-view" @click="showAddressInfo(item.order_id)"></i></p>
													</div>
												</div>
												<!--												<p class="red" style="margin-left: 14px;">总利润：{{item.total_partner_profit}}</p>-->
											</div>
											<div class="goods_pay">
												<div class="t1">实付：￥{{ item.pay_amount }}</div>
												<div class="t2">运费险：{{ item.post_insurance_amount }}</div>
												<div class="t2">平台优惠：{{ item.promotion_platform_amount }}</div>
												<div class="t2">精选联盟：{{ item.c_biz == 1 ? '是' : '否' }}</div>
												<!-- <p class="t3">采购价</p>
												<p class="t4">￥{{item.order_amount}}</p> -->
											</div>


											<div class="goods_buyer">
												<div v-if="item.order_after_sales">
													<div class="t1">退款金额：<span>{{ item.order_after_sales.refund_amount }}</span></div>
													<div class="t2" v-if="item.pdd_order?.refund_status > 0">采购退款状态：<span>{{ item.pdd_order?.refund_status_text }}</span></div>
													<div class="t2" v-if="item.pdd_order?.return_logistics_code">平台退货运费：<span>{{ item.pdd_order?.refund_freight }}</span></div>
													<div class="t2" style="text-align: justify;color: red;" v-if="item.lack_type">{{ item.lack_type_text }}{{ item.lack_day > 0 ? (item.lack_day + '天') : '' }}</div>
													<div class="t2" style="text-align: justify;color: red;" v-if="item.order_after_sales">{{ item.order_after_sales.text_part.aftersale_status_text }}</div>
													<div class="t2" style="text-align: justify;color: red;" v-if="item.order_after_sales">{{ item.order_after_sales.text_part.aftersale_type_text }}</div>
												</div>
												<div v-else>
													<div class="text-gray">暂无退货信息</div>
												</div>
												<div class="t2">
													<span class="return_address" v-if="item.return_address_state<=10" @click="editAlibabaAddress(item)">{{item.return_address_state_text}}<i class="el-icon-edit" style="margin-left: 5px;"></i></span>
													<span class="return_address exist" v-else @click="editAlibabaAddress(item)">{{item.return_address_state_text}}<i class="el-icon-edit" style="margin-left: 5px;"></i></span>
													<el-tooltip class="item" effect="dark"  v-if="item.return_address_state<= 0"  :content="item.return_address_error?item.return_address_error:'未创建'" placement="top">
														<i class="el-icon-warning" style="color: red;margin-left: 5px;"></i>
													</el-tooltip>
												</div>
											</div>
											<div class="goods_status">
												<p v-if="!item.pdd_order && !item.delete_time"><a href="javascript:;" class="details" @click="bindPurchase(item)">PDD采购</a></p>
												<p v-if="!item.pdd_order && !item.delete_time && item.source_type == 2"><a href="javascript:;" class="details" @click="bindAlibabaPurchaseNew(item)">厂家直采</a></p>
												<p v-if="!item.pdd_order && !item.delete_time && item.ready_stock_amount"><a href="javascript:;" class="details" @click="bindStockPurchase(item)">仓库直发</a></p>
												<p v-if="(item.pdd_order && !item.pdd_order?.order_id) || item.pdd_order?.status == 90"><a href="javascript:;" class="details" @click="delPurchase(item)">取消采购</a></p>
												<p v-if="item.pdd_order && item.pdd_order?.order_id"><a href="javascript:;" class="details" @click="needSyncOrder(item)">同步采购</a></p>
												<p><a href="javascript:;" class="details" @click="afterSales(item)">同步抖店</a></p>
												<p v-if="item.pdd_order?.is_deal == 1"><a href="javascript:;" class="details">处理中</a></p>
												<p v-if="item.pdd_order && item.pdd_order?.order_id && item.pdd_order?.status!=90 && item.pdd_order?.status!=105"><a href="javascript:;" class="details">采购成功</a></p>
												<p><a href="javascript:" class="details" v-if="item.pdd_order && item.pdd_order?.order_id && item.pdd_order?.status!=90 && item.pdd_order?.status_name=='待支付'" @click="toDoOrderPay(item)">去支付</a></p>
												<p v-if="item.pdd_order && item.pdd_order?.order_id && item.pdd_order?.status > 90 && item.pdd_order?.status != 130 && item.pdd_order?.status != 140"><a href="javascript:;" class="details" @click="repealPurchase(item)">重新采购</a></p>
												<p v-if="searchData.pdd_order_status < 130 && item.deliver_gift < 1"><a href="javascript:;" class="details" @click="sendGiftOrder(item.id)">发礼品单</a></p>
												<p v-if="item.pdd_status  == 140"><a href="javascript:;" class="details" @click="setNotDeal(item.id)">完结</a></p>
												<p v-if="!item.pdd_order && !item.delete_time"><a href="javascript:;" class="details" @click="postDeleteOrder(item.id)">删除</a></p>
												<p v-if="!item.pdd_order && item.delete_time > 0"><a href="javascript:;" class="details" @click="cancelDelete(item)">恢复</a></p>
											</div>
										</div>

										<div class="order_remarks" v-if="item.pdd_msg">
											<div class="remarks_item">
												<p class="txt red">采购备注：</p>
												<p class="remarks red">{{ item.pdd_msg ?? '利润差太低' }}</p>
											</div>
										</div>
										<div class="order_remarks">
											<div class="remarks_item" v-if="item.pdd_order">
												<p class="txt">采购账号：</p>
												<p class="remarks">
													<template v-if="item.pdd_order?.buy_mode == 3">
														<span>厂家直采</span>
													</template>
													<template v-else>
														<span>{{  isHideOrderInfo ? '******' : item.pdd_order?.account }}</span>
														<span @click="editPddAccount(item)" style="cursor: pointer;text-align: justify;">
							                            <i class="el-icon-edit" style="margin-left: 5px;"></i>
							                        </span>
														<span @click="editBuyMode(item)" style="cursor: pointer;text-align: justify;" class="ml-3 blue" v-if="item.pdd_order.status == 100">
							                            <i class="el-icon-refresh" style="margin-left: 5px;"></i>切换{{ item.pdd_order?.buy_mode == 1 ? '高效' : '普通' }}模式
							                        </span>
													</template>
													
												</p>
											</div>
											<div class="remarks_item">
												<p class="txt">采购单号：</p>
												<p class="remarks">
													<span>{{ item.pdd_order?.order_id }}</span>
													<span @click="editPddOrderNo(item)" style="cursor: pointer;text-align: justify;">
							                            <i class="el-icon-edit" style="margin-left: 5px;"></i>
							                        </span>
												</p>
											</div>
										</div>
										<div class="order_remarks">
											<div class="remarks_item">
												<p class="txt">买家留言：</p>
												<p class="remarks">{{ item.buyer_words }}</p>
											</div>
											<div class="remarks_item">
												<p class="txt">商家留言：</p>
												<p class="remarks">
													<span>{{ item.order.seller_words }}</span>
													<!-- <i class="iconfont el-icon-edit" @click="showRemark2(item.order_id)"></i> -->
													<span :label="star.val" v-for="(star,index) in arrStar" :key="index" v-if="item.order.seller_remark_stars==star.val">
														<i class="star" :class="star.icon" :style="{'color':star.color}"></i>
													</span>
													<span @click="showRemark(item.order_id)"
														style="cursor: pointer;text-align: justify;">
														<i class="el-icon-edit" style="margin-left: 5px;"></i>
													</span>
												</p>
											</div>
											<div class="remarks_item abnormal" v-if="item.is_abnormal==1">
												<txt>异常订单</txt>
											</div>
										</div>


										<div class="order_remarks" v-if="item.pdd_order?.express_no">
											<!--											<div class="remarks_item">-->
											<!--												<p class="txt">快递公司：</p>-->
											<!--												<p class="remarks">{{ item.pdd_order?.express }}</p>-->
											<!--											</div>-->
											<div class="remarks_item">
												<p class="txt">采购快递单号：</p>
												<p class="remarks">{{ item.pdd_order?.express_no }}</p>
											</div>
										</div>

										<div class="order_remarks" v-if="item.pdd_order?.return_logistics_code">
											<div class="remarks_item">
												<p class="txt">平台退货单号：</p>
												<p class="remarks">{{ item.pdd_order?.return_logistics_code }}</p>
											</div>
											<div class="remarks_item">
												<p class="txt">买家退货单号：</p>
												<p class="remarks">{{ item.order_after_sales?.return_logistics_code }}</p>
											</div>
										</div>

										<div class="order_remarks" v-if="item.pdd_order?.pdd_return_address?.id > 0">
											<div class="remarks_item">
												<p class="txt">退货地址：</p>
												<p class="remarks">{{ item.pdd_order?.pdd_return_address_encrypt }}
													<i class="el-icon-refresh" style="margin-left: 5px;cursor: pointer;" @click="refreshReturnAddress(item)"></i>
													<i class="el-icon-edit" style="margin-left: 5px;cursor: pointer;" @click="editAddress(item.pdd_order.pdd_return_encrypt_address)"></i>
												</p>
											</div>
										</div>

									</li>
								</el-checkbox-group>
								<li class="nodata" v-if="page_data.total == 0">暂无数据</li>
							</ul>
							<div class="turn_page">
								<Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getList" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10,50,100]"/>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 收货地址信息弹窗 -->
			<orderAddress @close="dialog.addressDialog = false" :isLoading.sync="isLoading" :show.sync="dialog.addressDialog" :order_id.sync="order_id"></orderAddress>
			<!-- 标记备注弹窗 -->
			<orderRemark @close="dialog.remarkDialog = false" @complete="refresh()" :isLoading.sync="isLoading" :show.sync="dialog.remarkDialog" :order_id.sync="order_id"></orderRemark>
			<!-- 售后详情弹窗 -->
			<el-dialog title="售后详情" :visible.sync="dialog.aftersaleDialog" width="70%" center>
				<orderAfterSales @close="dialog.aftersaleDialog = false" @complete="refresh()" :isLoading.sync="isLoading" :show.sync="dialog.aftersaleDialog" :info.sync="order_product"></orderAfterSales>
			</el-dialog>
			<!-- 选择拼多多账号 -->
			<pddAccountConfirm ref="pddAccountConfirm" :ali_order_type="ali_order_type" />
			<SetAutoGift ref="SetAutoGift"/>
			<SetAutoRefundReason ref="SetAutoRefundReason"/>
			<modifyConfirm ref="modifyConfirm" @refresh="refresh"/>
			<autoDelReturnAdress ref="autoDelReturnAdress" @refresh="refresh"/>
			<syncReturnAdressSet ref="syncReturnAdressSet" @refresh="refresh"/>
			<modifyReturnAddress ref="modifyReturnAddress"/>
			<orderReturnAddress ref="orderReturnAddress"  @close="initFilterData(),getList()"/>
			<modifyConfirmOrderNo ref="modifyConfirmOrderNo" @refresh="refresh"/>
			<!-- 订单支付弹窗 -->
			<orderPay @close="dialog.payDialog = false" @success="$router.go(0)" :show.sync="dialog.payDialog" :order_id.sync="order_id"></orderPay>
			<!-- 同步订单弹窗 -->
			<syncOrder @close="dialog.syncOrderDialog = false" :isLoading.sync="isLoading" :show.sync="dialog.syncOrderDialog"></syncOrder>
			<!-- 客服备注弹窗 -->
			<serviceRemark @close="dialog.remark2Dialog = false" @complete="refresh()" :isLoading.sync="isLoading" :show.sync="dialog.remark2Dialog" :order_id.sync="order_id"></serviceRemark>
		</div>
		<myFoot></myFoot>
		<connectGood ref="child" :dataArr="cg_data"></connectGood>
		<alibabaGoodsConnect ref="alibaba" :dataArr="cg_data"></alibabaGoodsConnect>
		<batchAlibabaConnect ref="batchAlibabaConnect" @refresh="onBatchAlibabaConnectRefresh"></batchAlibabaConnect>
		<syncDdOrderQueue ref="syncDdOrderQueue" :isLoading.sync="isLoading" :show.sync="dialog.syncDdOrderQueueDialog" @close="initFilterData(),dialog.syncDdOrderQueueDialog=false"></syncDdOrderQueue>
	</div>
</template>

<script>
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import orderAddress from '../../components/orderAddress/orderAddress';
import orderRemark from '../../components/orderRemark/orderRemark';
import serviceRemark from '../../components/serviceRemark/serviceRemark';
import connectGood from '../../components/connectGood/connectGood';
import orderAfterSales from '../../components/orderAfterSales/orderAfterSales';
import orderPay from '../../components/orderPay/orderPay';
import syncOrder from '../../components/syncOrder/syncOrder';
import Pagination from '../../components/pagination/pagination';
import pddAccountConfirm from "./components/pdd_account_confirm/index.vue";
import modifyConfirm from "./components/modify_confirm/index.vue";
import autoDelReturnAdress from "./components/auto_del_return_adress/index.vue";
import syncReturnAdressSet from "./components/sync_return_adress_set/index.vue";
import modifyConfirmOrderNo from "./components/modify_confirm_order_no/index.vue";
import modifyReturnAddress from "./components/modify_return_address/index.vue";
import orderReturnAddress from "./components/order_return_address/index.vue";
import SetAutoGift from "./components/set_auto_gift/index.vue";
import SetAutoRefundReason from "./components/set_auto_refund_reason/index.vue";
import {Loading} from 'element-ui';
import {mapActions, mapState,} from "vuex";
import headDefault from "@/assets/images/head.png";
import alibabaGoodsConnect from './components/alibaba_goods_connect/index.vue';
import batchAlibabaConnect from './components/batch_alibaba_connect/index.vue';
import syncDdOrderQueue from './components/sync_dd_order/index.vue';
export default {
	name: "ucenterOrders",
	data() {
		return {
			order_id: 0,
			options: [],
			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
			arrStatus: [],
			shopTypeList: [],
			arrStar: [],
			arrShop: [],
			arrAbnormal: [],
			arrAfterSales: [],
			arrPddStatus: [],
			sync_order_queue_count: 0,
			checkAll: false,
			checkList: [],
			isLoading: false,
			list: [],
			page_data: {
				limit: 10,
				page: 1,
				total: 0,
			},
			total_partner_profit: 0,
			searchData: {},
			dialog: {
				addressDialog: false,
				aftersaleDialog: false,
				remarkDialog: false,
				remark2Dialog: false,
				payDialog: false,
				syncOrderDialog: false,
				syncDdOrderQueueDialog: false,
			},
			cg_data: "",
			order_product: [],
			is_decrypt: 0,
			decrypt_state: 1,
			decrypt_msg: '',
			loading_service_id: 0,
			userinfo: {},
			isHideOrderInfo: false,
			ali_order_type: 0,
			platformTypeList: [
				{
					val: 1,
					text: '多多订单'
				},
				{
					val: 2,
					text: '巴巴订单'
				}
 			],
			firstLoad: true,
		}
	},
	components: {
		myHead, myFoot, ucMenu, orderAddress, connectGood, orderAfterSales, orderRemark, serviceRemark, orderPay, Pagination, syncOrder, pddAccountConfirm, modifyConfirm, modifyConfirmOrderNo, modifyReturnAddress,orderReturnAddress,SetAutoGift,SetAutoRefundReason,alibabaGoodsConnect,batchAlibabaConnect,autoDelReturnAdress,syncReturnAdressSet,syncDdOrderQueue
	},
	mounted(){
		const isHideInfo = localStorage.getItem('isHideInfo')
		if(isHideInfo == 1){
			this.isHideOrderInfo = true
		}
		// if(this.userinfo){
		// 	this.refreshUserinfo()
		// }
	},
	computed:{
		...mapState({
			users:(state)=>state.login.userinfo,
		}),
	},
	created() {
		var query = this.$route.query
		if (query.status) {
			this.searchData.pdd_order_status = Number(query.status)
		}
		if (query.after_sale) {
			this.searchData.after_sale_status = Number(query.after_sale)
		}
		if(this.users){
			this.userinfo = this.users
		}
		this.getList()
		
	},
	methods: {
		callCG(arr) {//打开子组件店铺列表
			this.cg_data = JSON.stringify(arr)
			this.$refs.child.showConnectGood()
		},
		alibabaCG(arr) {//打开子组件店铺列表（须先写入 cg_data，再打开弹窗，否则会读到上一次数据）
			this.cg_data = JSON.stringify(arr)
			this.$refs.alibaba.showConnectGood()
		},
		/** 厂家直采 pdd_code 有效：非空且不包含「规格失效」 */
		isValidAlibabaPddCode(item) {
			const c = item && item.pdd_code
			if (c === undefined || c === null || String(c).trim() === '') return false
			if (String(c).includes('规格失效')) return false
			return true
		},
		isAlibabaDirectLinked(item) {
			return Number(item.source_type) === 2 && this.isValidAlibabaPddCode(item)
		},
		openBatchAlibabaConnect() {
			if (!this.checkList.length) {
				this.$message({ message: '请先勾选订单', type: 'warning' })
				return
			}
			const bySku = new Map()
			for (const id of this.checkList) {
				const row = this.list.find((i) => i.id === id)
				if (!row) continue
				const key =
					row.sku_id != null && row.sku_id !== ''
						? String(row.sku_id)
						: `id_${row.id}`
				if (!bySku.has(key)) bySku.set(key, row)
			}
			const items = [...bySku.values()]
			if (!items.length) {
				this.$message({ message: '未找到勾选订单数据', type: 'warning' })
				return
			}
			this.$refs.batchAlibabaConnect.open(items)
		},
		onBatchAlibabaConnectRefresh() {
			this.getList(true, () => {
				const batch = this.$refs.batchAlibabaConnect
				if (batch && batch.visible) {
					batch.syncSkuItemsFromList(this.list)
				}
			})
		},
		...mapActions({
			getOrderManageList: "ucenter/getOrderManageList",
			getOrderManageAddressInfo: "ucenter/getOrderManageAddressInfo",
			getOrderManageDetail: "ucenter/getOrderManageDetail",
			getOrderManageFilterData: "ucenter/getOrderManageFilterData",
			opOrderManageBatPurchase: "ucenter/opOrderManageBatPurchase",
			opOrderManageCheckAliOrderType: "ucenter/opOrderManageCheckAliOrderType",
			opOrderManageBatAbnormal: "ucenter/opOrderManageBatAbnormal",
			opOrderManageReceipt: "ucenter/opOrderManageReceipt",
			opDdShopRefreshDecrypt: "ucenter/opDdShopRefreshDecrypt",
			opUnDecrypt: "ucenter/opUnDecrypt",
			opReDecrypt: "ucenter/opReDecrypt",
			opOrderManageDeleteProduct: "ucenter/opOrderManageDeleteProduct",
			opOrderManageDelPddOrder: "ucenter/opOrderManageDelPddOrder",
			opOrderManageSendGiftOrder: "ucenter/opOrderManageSendGiftOrder",
			opOrderManageSetNotDealOrder: "ucenter/opOrderManageSetNotDealOrder",
			opOrderManageRepealPurchase: "ucenter/opOrderManageRepealPurchase",
			opOrderManageNeedSyncPddOrder: "ucenter/opOrderManageNeedSyncPddOrder",
			opOrderManageUpdateOrderAfterSale: "ucenter/opOrderManageUpdateOrderAfterSale",
			opOrderManageCancelDelete: "ucenter/opOrderManageCancelDelete",
			opRefreshReturnAddress: "ucenter/opRefreshReturnAddress",
			opSetSellerWords: "ucenter/opSetSellerWords",
			opUpdatePddAccount: "ucenter/opUpdatePddAccount",
			opUpdatePddOrderNo: "ucenter/opUpdatePddOrderNo",
			opUpdateOrderProduct: "ucenter/opUpdateOrderProduct",
			opUpdateBuyMode: "ucenter/opUpdateBuyMode",
			opSetPddReturnAddress: "ucenter/opSetPddReturnAddress",
			opSetAutoSendGift: "ucenter/opSetAutoSendGift",
			opSetAutoRefundReason: "ucenter/opSetAutoRefundReason",
			opDoOrderPay: "ucenter/opDoOrderPay",
		}),
		initFilterData() {
			this.getOrderManageFilterData({
				data: this.searchData, success: (res) => {
					if (res.code === 200) {
						// console.log('get goods filter data',res)
						this.arrStatus = res.data.arr_status
						this.arrStar = res.data.arr_star
						this.arrAbnormal = res.data.arr_abnormal
						this.arrAfterSales = res.data.arr_after_sales
						this.arrShop = res.data.arr_shop
						this.shopTypeList = res.data.shop_types
						this.arrPddStatus = res.data.arr_pdd_status
						this.sync_order_queue_count = res.data.sync_order_queue_count
						if(this.firstLoad){
							this.firstLoad = false
							for(let i=0;i<this.arrPddStatus.length;i++){
								if(this.arrPddStatus[i].val == 122){
									//弹窗提示获取退货地址失败订单数
									if(this.arrPddStatus[i].num > 0){
										this.$alert('获取退货地址失败订单数：'+this.arrPddStatus[i].num, '提示', {
											confirmButtonText: '查看',
											cancelButtonText: '取消',
											center: true,
											showCancelButton: true,
											type: 'warning',
											callback: (action) => {
												if(action == 'confirm'){
													this.changeStatus(122)
												}
											}
										})
									}
									
								}
							}
						}
						
					}
				}
			})
		},
		//重置搜索
		resetSearch() {
			this.searchData = {}
			this.checkAll = false
			this.checkList = []
			this.getList()
		},
		//刷新列表
		refresh(nowPage = true) {
			if (!nowPage) {
				this.page_data.page = 1
			}
			this.checkAll = false
			this.checkList = []
			this.getList()
		},
		changeStatus(val) {
			this.searchData.pdd_order_status = val
			this.refresh(false)
		},
		doSearch() {
			this.page_data.page = 1
			this.checkAll = false
			this.checkList = []
			this.getList()
		},
		getList(showLoading = true, onDone) {
			if (showLoading) this.isLoading = true
			let loadingInstance = Loading.service({fullscreen: true});

			let param = {limit: this.page_data.limit, page: this.page_data.page}
			param = Object.assign(param, this.searchData)
			this.getOrderManageList({
				data: param, success: (res) => {
					if (res.code === 200) {
						// console.log('get order list',res)
						this.list = res.data.data
						this.page_data.total = res.data.total
						this.is_decrypt = res.data.is_decrypt
						this.decrypt_state = res.data.decrypt_state
						this.decrypt_msg = res.data.decrypt_msg
						this.total_partner_profit = res.data.total_partner_profit
						this.initFilterData()
					} else {
						this.$message({message: res.msg, type: 'error',});
					}
					this.isLoading = false
					loadingInstance.close()
					if (typeof onDone === 'function') {
						this.$nextTick(onDone)
					}
				}
			})
		},
		showAddressInfo(id) {
			this.order_id = id
			this.dialog.addressDialog = true
		},
		showOrderInfo(){
			//获取缓存数据
			const isHideInfo = localStorage.getItem('isHideInfo');

			if (isHideInfo == 1) {
				// 如果存在缓存数据，则将其解析为 JSON 对象
				localStorage.setItem('isHideInfo',0)
				this.isHideOrderInfo = false
			} else {
				localStorage.setItem('isHideInfo',1)
				this.isHideOrderInfo = true
			}
		},
		showRemark(id) {
			this.order_id = id
			this.dialog.remarkDialog = true
		},
		showRemark2(id) {
			this.order_id = id
			this.dialog.remark2Dialog = true
		},
		showAfterSaleInfo(order_product) {
			this.order_product = order_product
			this.dialog.aftersaleDialog = true
		},
		showPurchaseMsg(order_product) {
			this.$alert(order_product.purchase_msg, '采购状态', {
				type: 'warning',
				center: true
			});
		},
		bindCopy(text) {
			var str = ''
			var input = document.createElement("input"); // 创建input对象
			input.value = text; // 设置复制内容
			document.body.appendChild(input); // 添加临时实例
			input.select(); // 选择实例内容
			document.execCommand("Copy"); // 执行复制
			document.body.removeChild(input); // 删除临时实例
			this.$message({
				message: '复制成功',
				type: 'success'
			});

		},
		//全选
		bindCheckAll() {
			let checkAll = this.checkAll
			let list = this.list
			let checkList = []
			if (checkAll) {
				for (var i in list) {
					if (checkAll) {
						checkList.push(list[i].id)
					}
				}
			}
			this.checkList = checkList
		},
		//单项选
		bindCheckList() {
			let checkList = this.checkList
			if (checkList.length == this.list.length) {
				this.checkAll = true
			} else {
				this.checkAll = false
			}
		},
		//立即采购
		bindPurchase(row) {
			if (!row.is_authorize_print) {
				this.$message({
					type: 'error',
					message: '请先授权打单'
				})
				this.$router.push({name: 'ucenter'})
				return;
			}
			this.postPurchcase(row.id)
		},

		//批量厂家直采-新版
		bindBatAlibabaPurchase() {
			let that = this
			let checkList = this.checkList
			if (checkList.length == 0) {
				this.$message({ message: '请先选择需要采购的订单', type: 'error' })
				return;
			}
			let ids = checkList.join(',')
			this.$confirm('确认批量厂家直采操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				that.handleAlibabaPurchaseNew(ids)
			}).catch((res) => {
				console.log(res)
			});
		},
		//厂家直采-1688采购-新版
		bindAlibabaPurchaseNew(row){
			let that = this
			let ids = row.id
			this.$confirm('确认厂家直采操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				that.handleAlibabaPurchaseNew(ids)
			}).catch((res) => {
				console.log(res)
			});
		},
		//提交厂家直采-1688采购-新版
		handleAlibabaPurchaseNew(ids){
			let that = this
			let param = {
				ids: ids,
				buy_mode: 3
			}
			that.opOrderManageBatPurchase({
				data: param,
				success: (res) => {
					that.$alert(res.msg, '提示', {
						type: 'success',
						center: true,
						showCancelButton: true,
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						callback: (action) => {
							if (action == 'confirm') {
								that.refresh()
								if (res.msg && res.msg.includes('请先开通免密支付')) {
									that.showOpenPay()
								}
							} else if (action == 'cancel') {
								that.refresh()
							}
						}
					})
				}
			})
		},
		//厂家直采-1688采购-旧版
		bindAlibabaPurchaseOld(row){
			let that = this
			let param = {
				ids:row.id,
				account_id: -1, 
				buy_mode: 3,
				group_id: row.dd_shop.group_id
			}
			that.opOrderManageCheckAliOrderType({
				data: param,
				success: (res) => {
					if (res.code == 200) {
						if (res.data.ali_order_type[0].type == 2) {
							that.postPurchcase(param.ids,2,row.dd_shop.group_id)
						}else if (res.data.ali_order_type[0].type == 1){
							that.opOrderManageBatPurchase({
								data: param,
								success: (res) => {
									if (res.code == 200) {
										this.$message({
											type: 'success',
											message: res.msg
										})
										this.refresh()
									} else {
										if (res.msg == '请先开通免密支付') {
											this.showOpenPay()
										}else{
											this.$message({
												type: 'error',
												message: res.msg
											});
										}

									}
								}
							})
						}
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				}
			})
			
				
		},
		//仓库直发
		bindStockPurchase(row) {
			let that = this
			let param = {
				ids:row.id,
				account_id: -1, 
				buy_mode: 4
			}
			this.$confirm('确认仓库直发?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				that.opOrderManageBatPurchase({
					data: param,
					success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
			
		},
		//批量采购
		bindBatPurchase() {
			let checkList = this.checkList
			// todo 遍历
			const _list = {}
			this.list.map(item => {
				_list[item.id] = item.is_authorize_print
			})

			for (let id of this.checkList) {
				if (!_list[id]) {
					this.$message({
						type: 'error',
						message: '请先授权打单'
					})
					this.$router.push({name: 'ucenter'})
					return;
				}
			}
			let ids = checkList.join(',')
			this.postPurchcase(ids)
		},
		
		//批量取消采购
		bindBatCancelPurchase() {
			let checkList = this.checkList
			if (checkList.length == 0) {
				this.$message({message: '请勾选订单', type: 'error'})
				return;
			}
			// todo 遍历
			const _list = {}
			this.list.map(item => {
				_list[item.id] = item.is_authorize_print
			})

			for (let id of this.checkList) {
				if (!_list[id]) {
					this.$message({
						type: 'error',
						message: '请先授权打单'
					})
					this.$router.push({name: 'ucenter'})
					return;
				}
			}
			let ids = checkList.join(',')
			this.$confirm('确认取消采购操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opOrderManageDelPddOrder({
					data: {ids: ids},
					success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		// 批量删除
		bindBatDelete() {
			let checkList = this.checkList
			let ids = checkList.join(',')
			this.postDeleteOrder(ids)
		},
		cancelDelete(row) {
			this.$confirm('确认恢复操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opOrderManageCancelDelete({
					data: {ids: row.id}, success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		postDeleteOrder(ids) {
			this.$confirm('确认删除操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opOrderManageDeleteProduct({
					data: {ids: ids},
					success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		//采购请求
		postPurchcase(ids,ali_order_type = 0,group_id = '') {
			let that = this
			let param = {ids: ids, ali_order_type: ali_order_type,group_id: group_id}
			that.ali_order_type = ali_order_type
			this.$refs.pddAccountConfirm.open(
				param,
				this.opOrderManageBatPurchase,
				(res) => {
					if (res.code == 200) {
						that.$message({
							type: 'success',
							message: res.msg
						})
						that.refresh()
					} else {
						if (res.msg == '请先开通免密支付') {
							this.showOpenPay()
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					}
				}
			)
		},
		//订单导出
		orderExport() {
			if (this.isLoading) return
			this.$confirm('确认导出订单操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.isLoading = true
				let loadingInstance = Loading.service({fullscreen: true});
				let param = {limit: this.page_data.limit, page: this.page_data.page, is_export: 1, order_ids: this.checkList}
				Object.assign(param, this.searchData)
				this.getOrderManageList({
					data: param, success: (res) => {
						this.isLoading = false;
						loadingInstance.close()
						if (res.code === 200) {
							// window.open(res.data)
							window.location.href = res.data
						} else {
							this.$message({message: res.msg, type: 'error',});
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		sendGiftOrder(id = null) {
			let checkList = this.checkList
			if (id !== null) {
				checkList = [id]
			}
			let ids = checkList.join(',')
			if (checkList.length === 0) {
				this.$message({message: '请勾选订单', type: 'error'})
				return;
			}
			this.$confirm('确认发送礼品单操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opOrderManageSendGiftOrder({
					data: {ids: ids},
					success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		setNotDeal(id = null) {
			let checkList = this.checkList
			if (id !== null) {
				checkList = [id]
			}
			let ids = checkList.join(',');
			if (checkList.length === 0) {
				this.$message({message: '请勾选订单', type: 'error'})
				return;
			}
			this.$confirm('确认完结该订单? 确认后不可逆', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opOrderManageSetNotDealOrder({
					data: {ids: ids},
					success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		openAutoGift(){
			let param = {}
			let that = this
			this.$refs.SetAutoGift.open(
				param,
				this.opSetAutoSendGift,
				(res) => {
					if (res.code == 200) {
						that.$message({
							type: 'success',
							message: res.msg
						})
						that.refresh()
					} else {
						that.$message({
							type: 'error',
							message: res.msg
						})
					}
				}
			)
		},
		openAutoRefundReason(){
			let param = {}
			let that = this
			this.$refs.SetAutoRefundReason.open(
				param,
				this.opSetAutoRefundReason,
				(res) => {
					if (res.code == 200) {
						that.$message({
							type: 'success',
							message: res.msg
						})
						that.refresh()
					} else {
						that.$message({
							type: 'error',
							message: res.msg
						})
					}
				}
			)
		},
		datePick() {
			console.log(111)
		},
		//放弃解密
		unDecrypt(ids) {
			var that = this
			this.$confirm('确认放弃解密？', '提示', {
				confirmButtonText: 'YES',
				cancelButtonText: 'NO',
				type: 'info',
				center: true
			}).then(() => {

				that.opUnDecrypt({
					data: {ids: ids}, success: (res) => {
						if (res.code == 200) {
							that.$message({
								type: 'success',
								message: res.msg
							})
							that.refresh()
						} else {
							that.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})

			})
		},
		//批量放弃解密
		batUnDecrypt() {
			let checkList = this.checkList
			let ids = checkList.join(',')
			this.unDecrypt(ids)
		},
		//恢复解密
		reDecrypt(ids) {
			var that = this
			this.$confirm('确认恢复解密？', '提示', {
				confirmButtonText: 'YES',
				cancelButtonText: 'NO',
				type: 'info',
				center: true
			}).then(() => {
				that.opReDecrypt({
					data: {ids: ids}, success: (res) => {
						if (res.code == 200) {
							that.$message({
								type: 'success',
								message: res.msg
							})
							that.refresh()
						} else {
							that.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})

			})
		},
		//批量恢复解密
		batReDecrypt() {
			let checkList = this.checkList
			let ids = checkList.join(',')
			this.reDecrypt(ids)
		},
		delPurchase(row) {
			this.$confirm('确认取消采购操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opOrderManageDelPddOrder({
					data: {ids: row.id},
					success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		needSyncOrder(row) {
			this.$confirm('确认同步采购操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opOrderManageNeedSyncPddOrder({
					data: {ids: row.id},
					success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		afterSales(row) {
			this.$confirm('确认同步抖店操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opOrderManageUpdateOrderAfterSale({
					data: {ids: row.id},
					success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		repealPurchase(row) {
			this.$confirm('确认重新采购操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opOrderManageRepealPurchase({
					data: {ids: row.id},
					success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});

		},
		refreshReturnAddress(row) {
			this.$confirm('确定重新获取地址吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				this.opRefreshReturnAddress({
					data: {ids: row.id},
					success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch((res) => {
				console.log(res)
			});
		},
		editAddress(row) {
			this.$refs.modifyReturnAddress.open(
				'修改退货地址',
				row,
				this.opSetPddReturnAddress,
				(row) => {
					const map = [
						'id', 'name', 'phone', 'province_name',
						'city_name', 'town_name', 'street_name', 'detail',
					]
					const detail = {};
					for (let key of map) {
						detail[key] = row[key]
					}
					return detail;
				},
				() => {
					this.refresh();
				}
			)
		},
		editReturnAddressExpireDay() {
			this.$refs.autoDelReturnAdress.open(
				'退换货地址自动删除天数'
			)
		},
		editSyncReturnAddressSet() {
			this.$refs.syncReturnAdressSet.open()
		},
		editAlibabaAddress(row) {
			this.$refs.orderReturnAddress.open(
				'退换货地址',
				row.dd_order_id,
				() => {
					this.refresh();
				}
			)
		},
		openSyncDdOrderQueue() {
			this.dialog.syncDdOrderQueueDialog = true
			console.log(222,this.dialog.syncDdOrderQueueDialog)
		},
		editProductCode(row, index) {
			let pdd_sku_id = ''
			this.$refs.modifyConfirm.open(
				'商品编码',
				row.pdd_sku_id ?? row.pdd_code,
				this.opUpdateOrderProduct,
				(val) => {
					pdd_sku_id = val
					return {
						pdd_sku_id: val,
						id: row.id
					}
				},
				(res) => {
					if (res.code == 200) {
						this.$message({
							type: 'success',
							message: res.msg
						})
						// this.refresh(true)
						this.list[index].pdd_sku_id = pdd_sku_id
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				}
			)
		},
		editPddAccount(row) {
			this.$refs.modifyConfirm.open(
				'采购账号',
				row.pdd_order.account,
				this.opUpdatePddAccount,
				(val) => {
					return {
						account: val,
						ids: row.id
					}
				},
				(res) => {
					if (res.code == 200) {
						this.$message({
							type: 'success',
							message: res.msg
						})
						this.refresh()
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				}
			)
		},
		editPddOrderNo(row) {
			this.$refs.modifyConfirmOrderNo.open(
				'设置采购单号',
				{order_no: row.pdd_order?.order_id, account: row.pdd_order?.account},
				this.opUpdatePddOrderNo,
				(val) => {
					return {
						pdd_order_no: val.pdd_order_no,
						pdd_account_id: val.pdd_account_id,
						ids: row.id
					}
				},
				(res) => {
					if (res.code == 200) {
						this.$message({
							type: 'success',
							message: res.msg
						})
						this.refresh()
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				}
			)
		},
		editBuyMode(row) {
			this.$confirm('确定切换采购模式吗? 切换后请重新启动任务', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.opUpdateBuyMode({
					data: {ids: row.id}, success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					}
				})
			}).catch(() => {
			});
		},
		toDoOrderPay(row) {
			this.$confirm('确定支付该采购订单吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.opDoOrderPay({
					data: {ids: row.id}, success: (res) => {
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: res.msg
							})
							this.refresh()
						} else {
							if (res.msg == '支付失败未签约或未绑定') {
								this.showOpenPay()
							}else{
								this.$message({
									type: 'error',
									message: res.msg
								})
							}
							
						}
					}
				})
			}).catch(() => {
			});
		},
		editSellerWords(row) {
			this.$refs.modifyConfirm.open(
				'商家留言',
				row.order.seller_words,
				this.opSetSellerWords,
				(val) => {
					return {
						seller_words: val,
						order_id: row.order_id
					}
				},
				(res) => {
					if (res.code == 200) {
						this.$message({
							type: 'success',
							message: res.msg
						})
						this.refresh()
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				},
				'textarea'
			)
		},
		openImg(row) {
			console.log(row)
			let htm = '<img style="object-fit: cover;margin-right: 10px;max-height:70vh;" src="' + row.product_pic + '" alt="">'
			htm += '<div style="margin-top:10px;font-size:16px;">' + row.spec_value + '</div>';
			htm += '<div style="margin-top:5px;font-size:16px;">实付:￥' + row.pay_amount + '</div>';
			this.$alert(htm, row.product_name, {
				dangerouslyUseHTMLString: true,
				showClose: false,
				confirmButtonText: '关闭',
				closeOnClickModal: true,
				customClass: 'zdy-message-box'
			});
		},
		showOriginalOrder(dd_order_id, type = 1) {
			console.log(dd_order_id.substring(0, dd_order_id.length - 1));
			if (type === 2) {
				this.searchData.dd_order_id = dd_order_id;
			} else {
				this.searchData.dd_order_id = dd_order_id.substring(0, dd_order_id.length - 1);
			}
			this.refresh();
		},
		showOpenPay(){
			let html = `<div>
					<p style="font-weight: bold;font-size: 14px;">开启后，免密订单笔数无限制，采购更快捷</p>
					<p style="font-size: 12px;">1、请使用当前登录的1688账号绑定支付宝；</p>
					<p style="font-size: 12px;">2、且务必宝石支付宝余额充足，余额不足将不能支付；</p>
					<p style="font-size: 12px;">3、单笔支付限额500元/笔;支付笔数不限。</p>
				</div>`
			this.$alert(html, '请先开通支付宝免密支付', {
				dangerouslyUseHTMLString: true,
				confirmButtonText: '去开通',
				cancelButtonText: '暂不开通',
				closeOnClickModal: true,
				closeOnPressEscape: true,
				showClose: false,
				showCancelButton: true,
				customClass: 'zdy-message-box'
			}).then(() => {
				window.open('https://tradeconfig.1688.com/foundation/withhold_manage.htm')
			})
		}
	}
}
</script>

<style lang="less" scoped>
.wrap .wrap_body {
	display: flex;
	flex-direction: column;
}

.center {
	display: flex;
	flex: 1;
}

.ucenter_main {
	padding: 30px 0 40px;
	display: flex;
	justify-content: space-between;
	flex: 1;
}

.right_con {
	width: 980px;
	background: #fff;
}

.goods_main {
	padding: 36px 40px 46px;
	min-height: 70vh;
}

.select_wrap {
	margin-top: 24px;
	display: flex;
	flex-wrap: wrap;
}

.select_wrap .mr {
	margin-right: 15px;
}

.select_wrap .w290 {
	width: 290px;
	margin-top: 14px;
	margin-right: 15px;
}

.select_wrap .w290:nth-child(3n) {
	margin-right: 0;
}

.select_wrap .label_title {
	width: 96px;
	height: 100%;
	font-size: 12px;
	color: #999;
	display: flex;
	align-items: center;
	padding-left: 6px;
}

.select_wrap .label_title .icon-shuoming {
	font-size: 12px;
	color: #999;
	margin-left: 2px;
}

.tabs_wrap {
	width: 100%;
	height: 60px;
	border-bottom: 1px solid #eee;
	display: flex;
	justify-content: space-between;
}

.tabs_wrap .tab {
	height: 100%;
	padding: 30px 5px 0;
	position: relative;
	line-height: 1;
	cursor: pointer;
	font-size: 14px;
	color: #666;
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	align-items: center;
}

.tabs_wrap .tab .mark {
	position: absolute;
	vertical-align: middle;
	display: inline-block;
	right: -10px;
	bottom: 10px;
}

.tabs_wrap .tab.active {
	font-weight: bold;
	color: var(--red);
}

.tabs_wrap .tab.active::after {
	content: '';
	width: 100%;
	height: 3px;
	background: var(--red);
	position: absolute;
	left: 0;
	bottom: 0;
	z-index: 2;
}

.tabs_wrap .tab .iconfont {
	font-size: 14px;
	color: #1966ff;
	margin-left: 4px;
}

.totals_btn {
	margin-top: 14px;
	display: flex;
	align-items: center;
}

.totals_btn .totals {
	font-size: 12px;
	color: #333;
	padding-right: 16px;
	margin-right: 16px;
	line-height: 1;
	border-right: 1px solid #ccc;
}

.total_profit {
	margin-left: 10px;
	font-size: 14px;
}

.totals_btn .decrypt_msg {
	font-size: 14px;
	color: var(--red);
	padding-left: 10px;
}

.list_title {
	width: 100%;
	height: 50px;
	background: #f9f9f9;
	margin-top: 10px;
	display: flex;
	align-items: center;
	font-size: 12px;
	color: #666;
	line-height: 1;
}

.list_title .checkall {
	margin-left: 20px;
}

.list_title .t1 {
	margin-left: 10px;
	width: 182px;
}

.list_title .t2 {
	margin: 0 20px;
	width: 60px;
	text-align: right;
}

.list_title .t3 {
	margin: 0 10px;
	width: 140px;
	text-align: left;
}

.list_title .t4 {
	margin-left: 20px;
	width: 100px;
	text-align: right;
}

.list_title .t5 {
	margin: 0 20px;
	width: 130px;
	text-align: left;
}

.list_title .t6 {
	margin: 0 20px 0 0;
	flex: 1;
	text-align: left;
}

.list_title .t7 {
	margin: 0 20px 0 0;
	flex: 1;
	text-align: right;
}

.list_title .t8 {
	margin: 0 20px 0 0;
	flex: 1;
	text-align: right;
}

.order_list li {
	margin-top: 10px;
	font-size: 12px;
}

.order_list li .info_top {
	background: #fff6f7;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.order_list li .info_top .order_flag .flag_box {
	white-space: nowrap;
	padding: 2px 7px;
	color: #fff;
	background: red;
	border-radius: 3px;
	cursor: pointer;
}

.order_list li .info_top .order_flag .flag_box.old {
	background: #0990c0;
}

.order_list li .order_nums {
	width: 100%;
	height: 40px;
	background: #fff6f7;
	display: flex;
	align-items: center;
	position: relative;
}

.order_list li .order_nums .btn-remark {
	position: absolute;
	right: 20px;
	cursor: pointer;
	font-size: 14px;
}

.order_list li .order_nums .check_box {
	margin-left: 20px;
}

.order_list li .order_nums .num {
	display: flex;
	align-items: center;
	margin-left: 12px;
	color: #666666;
}

.order_list li .order_nums .num .iconfont {
	cursor: pointer;
	font-size: 14px;
	color: #666;
	margin-left: 8px;
}

.order_list li .order_nums .date {
	margin-left: 26px;
	color: #666666;
}

.order_list li .order_nums .maoli {
	margin-left: 30px;
	color: #666666;
}

.order_list li .order_info {
	padding: 20px 0;
	border-bottom: 1px dashed #eee;
	display: flex;
	align-items: flex-start;
	line-height: 1;
}

.order_list li .order_info .order_product {
	display: flex;
	flex-direction: column;
}

.order_list li .order_info .order_product .product_item {
	display: flex;
	padding-bottom: 20px;
}

.order_list li .order_info .order_product .product_item:last-child {
	padding-bottom: 0;
}

.order_list li .order_info .goods_info {
	width: 242px;
	display: flex;
	margin-left: 20px;
}

.order_list li .order_info .goods_info .img_box {
	width: 48px;
	height: 48px;
	background-color: #eeeeee;
	border-radius: 6px;
	overflow: hidden;
	cursor: pointer;
}

.order_list li .order_info .goods_info .con_box {
	flex: 1;
	width: 0;
	margin-left: 10px;
}

.order_list li .order_info .goods_info .con_box .title {
	line-height: 16px;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
}

.order_list li .order_info .goods_info .con_box .t1 {
	color: #999999;
	margin-top: 12px;
	line-height: 14px;
}

.order_list li .order_info .goods_info .con_box .t2 {
	color: #999999;
	margin-top: 8px;
}

.order_list li .order_info .goods_info .con_box .t2 .sp_remark {
	display: inline-block;
	max-width: 100%;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	color: #f0b92c;
}

.order_list li .order_info .goods_info .con_box .stock_msg {
	color: var(--red);
	margin-top: 8px;
	display: flex;
	justify-content: space-between;
}

.order_list li .order_info .goods_info .con_box .guanlian {
	color: #1966ff;
	margin-top: 8px;
	cursor: pointer;
}

.order_list li .order_info .goods_info .con_box .guanlian:hover {
	text-decoration: underline;
}

.order_list li .order_info .goods_num {
	margin: 0 20px;
	width: 60px;
	text-align: right;
}

.order_list li .order_info .goods_num .t1 {
	color: #333333;
}

.order_list li .order_info .goods_num .t2 {
	color: #999999;
	margin-top: 10px;
}

.order_list li .order_info .goods_sales {
	margin: 0 10px;
	width: 140px;
	text-align: left;
}

.order_list li .order_info .goods_sales > p {
	line-height: 18px;
	color: #333;
}

.order_list li .order_info .goods_sales > p.red {
	color: var(--red);
	cursor: pointer;
}

.order_list li .order_info .goods_pay {
	margin-left: 20px;
	width: 100px;
	text-align: right;
}

.order_list li .order_info .goods_pay .t1 {
	color: #333333;
}

.order_list li .order_info .goods_pay .t2 {
	color: #333333;
	margin-top: 10px;
}

.order_list li .order_info .goods_pay .t3 {
	color: #666666;
	margin-top: 20px;
}

.order_list li .order_info .goods_pay .t4 {
	color: #666666;
	margin-top: 10px;
}

.order_list li .order_info .goods_buyer {
	margin: 0 20px;
	width: 130px;
	text-align: left;
}

.order_list li .order_info .goods_buyer .t1 {
	color: #333333;
}

.order_list li .order_info .goods_buyer .t2 {
	color: #333333;
	margin-top: 10px;
}

.order_list li .order_info .goods_buyer .t2 .return_address{
	cursor: pointer;
	color: #666;
}
.order_list li .order_info .goods_buyer .t2 .return_address.exist{
	cursor: pointer;
	color: #00aa00;
}
.order_list li .order_info .goods_buyer .t2 .return_address:hover{
	text-decoration: underline;
}
.order_list li .order_info .goods_buyer .t3 {
	color: #666666;
	margin-top: 20px;
}

.order_list li .order_info .goods_buyer .t4 {
	color: #666666;
	margin-top: 10px;
}

.order_list li .order_info .goods_buyer > p {
	line-height: 18px;
	color: #666;
}

.order_list li .order_info .goods_buyer > p .iconfont {
	cursor: pointer;
	font-size: 12px;
	color: #666;
	margin-left: 8px;
}

.order_list li .order_info .goods_status {
	margin: 0 20px 0 0;
	flex: 1;
	text-align: left;
}

.order_list li .order_info .goods_status:last-child {
	text-align: right;
}

.order_list li .order_info .goods_status > p {
	margin-bottom: 10px;
}

.order_list li .order_info .goods_status .details {
	color: #f0413e;
	cursor: pointer;
}

.order_list li .order_info .goods_status .details:hover {
	text-decoration: underline;
}

.order_list li .order_info .goods_status p > a {
	color: #f0413e;
	cursor: pointer;
}

.order_list li .order_info .goods_status p > a:hover {
	text-decoration: underline;
}

.order_list li .order_remarks {
	padding: 10px 0;
	border-bottom: 1px solid #eee;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-left: 66px;
}

.order_list li .order_remarks .remarks_item {
	display: flex;
	flex: 1;
}

.order_list li .order_remarks .remarks_item.abnormal {
	width: 100px;
	flex: unset;
	text-align: right;
	color: #f0b92c;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-right: 10px;
	font-weight: bold
}

.order_list li .order_remarks .txt {
	font-size: 12px;
	color: #999999;
	line-height: 18px;
	max-width: 110px;
	box-sizing: border-box;
	padding-left: 10px;
}

.order_list li .order_remarks .remarks {
	flex: 1;
	width: 0;
	font-size: 12px;
	color: #333;
	line-height: 18px;
}

.turn_page {
	display: flex;
	justify-content: flex-end;
	margin-top: 30px;
}

.order_list li .order_remarks .remarks i {
	cursor: pointer;
}

.order_list li .check_box {
	margin-left: 20px;
	height: 48px;
	display: flex;
	align-items: center;
}

/deep/ .order_list li .check_box .el-checkbox__label {
	display: none !important;
}

.order_list .shop_name {
	max-width: 120px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	display: inline-block;
	margin-right: 5px;
}
</style>
<style>
.el-button+.el-button {
    margin-left: 5px;
}
.has-time .el-button {
	padding: 7px 15px;
}

.select_wrap .el-button {
	margin-top: 14px;
}

.select_wrap .el-range-editor .el-range-input {
	font-size: 1em;
}

.select_wrap .el-input--prefix .el-input__inner {
	padding-left: 96px !important;
	height: 34px !important;
	line-height: 34px !important;
	font-size: 12px !important;
}

.el-select .el-input.is-focus .el-input__inner, .el-select .el-input__inner:focus {
	border-color: var(--red);
}

.el-select-dropdown__item.selected {
	color: var(--red);
}

.select_wrap .el-input--prefix .el-input__inner:focus {
	border-color: var(--red);
}

.el-date-editor .el-range-separator {
	line-height: 26px;
}

.el-date-editor {
	width: 290px !important;
	height: 34px !important;
	line-height: 34px !important;
	font-size: 12px !important;
	margin-top: 14px;
}

.el-range-editor.is-active, .el-range-editor.is-active:hover {
	border-color: var(--red);
}

.el-date-table td.end-date span, .el-date-table td.start-date span {
	background-color: var(--red);
}

.el-date-table td.today span {
	color: var(--red);
}

.el-picker-panel__icon-btn:hover, .el-date-table td span:hover, .el-date-table td div:hover, .el-date-table td.available:hover, .el-picker-panel__shortcut:hover {
	color: var(--red);
}

.el-button {
	color: #333;
	border-color: #ddd;
}

.el-button--small {
	padding: 6px 4px !important;
}

.el-checkbox {
	color: #666;
	display: flex;
	align-items: center;
}

.el-checkbox__inner {
	border-color: #ddd;
	width: 16px;
	height: 16px;
}

.el-checkbox__input {
	display: flex;
}

.el-checkbox__label {
	font-size: 12px;
	line-height: 1;
}

.el-checkbox__inner::after {
	height: 9px;
	left: 5px;
}

.el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
	height: 4px;
}

/*red border color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__inner:hover, .el-checkbox__input.is-focus .el-checkbox__inner, .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus {
	border-color: var(--red);
}

/*red color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked + .el-checkbox__label, .el-pager li.active, .el-pagination button:hover, .el-pager li:hover {
	color: var(--red);
}

/*red background color*/
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: var(--red);
}

.el-input__icon {
	line-height: unset;
}

.el-button--primary, .el-button--primary:hover {
	background-color: var(--red) !important;
	border-color: var(--red) !important;
	color: #fff !important;
}

.el-button:hover {
	border-color: var(--red) !important;
	background-color: rgba(240, 65, 62, 0.1) !important;
	color: var(--red) !important;
}

.el-date-editor--datetimerange .el-icon-time {
	line-height: 28px;
}

.el-date-editor .el-range-separator {
	width: 20px;
}

.red {
	color: var(--red) !important;
}
.star {
	font-size: 16px;
}
</style>
